// import {useState} from 'react';
// import './App.css';
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Navbar from './components/Navbar';
// import Home from './components/Home';
// import About from './components/About';
// import NoteState from './context/notes/NoteState';
// import Alert from './components/Alert';
// import Login from './components/Login';
// import Signup from './components/Signup';
// function App() {
//   const [alert,setAlert] = useState(null);
//   const showAlert = (message,type)=>
//   {
//     setAlert({
//       msg:message,
//       type:type
//     })
//     setTimeout(()=>{
//       setAlert(null);
//     },1500);
//   }
//   return (
//     <>
//       <NoteState>
//         <Router>
//           <Navbar/>
//           <Alert alert={alert} />
//           <div className="container">
//             <Routes>
//               <Route exact path="/" element={<Home  showAlert={showAlert}/>} ></Route>
//               <Route exact path="/about" element={<About />} ></Route>
//               <Route exact path="/login" element={<Login  showAlert={showAlert}/>} ></Route>
//               <Route exact path="/signup" element={<Signup  showAlert={showAlert} />} ></Route>
//             </Routes>
//           </div>
//         </Router>
//       </NoteState>
//     </>
//   );
// }

// export default App;


import { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet"; // ✅ Import Helmet

import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import NoteState from './context/notes/NoteState';
import Alert from './components/Alert';
import Login from './components/Login';
import Signup from './components/Signup';

function App() {
  const [alert,setAlert] = useState(null);

  const showAlert = (message,type) => {
    setAlert({
      msg: message,
      type: type
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  }

  return (
    <>
      {/* ✅ Meta tags for charset and theme-color */}
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="theme-color" content="#282c34" />
      </Helmet>

      <NoteState>
        <Router>
          <Navbar/>
          <Alert alert={alert} />
          <div className="container">
            <Routes>
              <Route exact path="/" element={<Home showAlert={showAlert}/>} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/login" element={<Login showAlert={showAlert}/>} />
              <Route exact path="/signup" element={<Signup showAlert={showAlert}/>} />
            </Routes>
          </div>
        </Router>
      </NoteState>
    </>
  );
}

export default App;

